export default __webpack_public_path__ + "static/sam-8eab26b52c24d48bf9ecdf22d29cce07.jpg";